import React, { useCallback, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {
    Squares2X2Icon,
    EnvelopeIcon,
    WrenchIcon,
    UsersIcon
} from '@heroicons/react/24/outline';
import { useFirestore } from '../../hooks/useFirestore';
import { getServices } from '../../firebase/firestore';
import { collection, query, getDocs, setDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Card from '../../components/common/Card';
import './DashboardOverview.css';

const DashboardOverview = () => {
    const { data: services } = useFirestore(useCallback(() => getServices(), []));
    const { data: clients } = useFirestore(useCallback(() => getDocs(query(collection(db, 'clients'))).then(snapshot => snapshot.docs), []));
    const [inquiryCount, setInquiryCount] = useState(0);

    useEffect(() => {
        const fetchInquiries = async () => {
            const q = query(collection(db, 'inquiries'));
            const snapshot = await getDocs(q);
            setInquiryCount(snapshot.size);
        };
        fetchInquiries();
    }, []);

    const stats = [
        { label: 'الخدمات', value: services?.length || 0, icon: WrenchIcon, color: '#3b82f6' },
        { label: 'الاستفسارات', value: inquiryCount, icon: EnvelopeIcon, color: '#10b981' },
        { label: 'العملاء', value: clients?.length || 0, icon: UsersIcon, color: '#f59e0b' },
    ];

    return (
        <div className="dashboard-overview">
            <h1 className="admin-page-title">نظرة عامة</h1>

            <div className="stats-grid">
                {stats.map((stat, index) => (
                    <motion.div
                        key={stat.label}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <Card className="stat-card">
                            <div className="stat-icon" style={{ backgroundColor: `${stat.color}15`, color: stat.color }}>
                                <stat.icon className="icon-inner" />
                            </div>
                            <div className="stat-info">
                                <h3>{stat.value}</h3>
                                <p>{stat.label}</p>
                            </div>
                        </Card>
                    </motion.div>
                ))}
            </div>

            <div className="quick-actions">
                <h2>روابط سريعة</h2>
                <div className="actions-grid">
                    <Card className="action-card" onClick={() => { }}>
                        <WrenchIcon className="action-icon" />
                        <span>إضافة خدمة جديدة</span>
                    </Card>
                    <Card className="action-card" onClick={() => { }}>
                        <EnvelopeIcon className="action-icon" />
                        <span>عرض آخر الرسائل</span>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default DashboardOverview;
